module.exports = __webpack_public_path__ + "img/title_blue.80edadb1.png";